export default __webpack_public_path__ + "static/media/Rustoleum-Banner.61b8721c.jpg";